import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LoginComponent } from './components/login/login.component';
import { AuthenticationRoutingModule } from './authentication-routing.module';
import { AuthenticationHomeComponent } from './components/authentication-home/authentication-home.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { RegistrationComponent } from './components/registration/registration.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { PhoneMaskDirective } from './directives/phone-mask.directive';
import { RegistrationFormComponent } from './components/registration-form/registration-form.component';
import { CommonLayoutModule } from '../common-layout/common-layout.module';
import { SignInComponent } from './components/sign-in/sign-in.component';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { PipesModule } from '../pipes/pipes.module';
import { ForgotPasswordComponent } from './components/forgot-password/forgot-password.component';
import { ResetPasswordComponent } from './components/reset-password/reset-password.component';
import { AutoFocusDirective } from './auto-focus.directive';
import { NgSelectModule } from '@ng-select/ng-select';
import { EnterPasswordLoginComponent } from './components/enter-password-login/enter-password-login.component';
import { SetPasswordCloudComponent } from './components/set-password-cloud/set-password-cloud.component';


@NgModule({
  declarations: [
    LoginComponent,
    AuthenticationHomeComponent,
    RegistrationComponent,
    PhoneMaskDirective,
    RegistrationFormComponent,
    SignInComponent,
    ForgotPasswordComponent,
    ResetPasswordComponent,
    AutoFocusDirective,
    EnterPasswordLoginComponent,
    SetPasswordCloudComponent
  ],
  imports: [
    CommonModule,
    AuthenticationRoutingModule,
    NgbModule,
    FormsModule,
    NgSelectModule,
    ReactiveFormsModule,
    CommonLayoutModule,
    FontAwesomeModule,
    PipesModule
  ],
  exports: [
    RegistrationFormComponent,
    LoginComponent
  ]
})
export class AuthenticationModule { }
